export enum BLOG_FILTER {
  CATEGORY = 'CATEGORY',
  TAG = 'TAG',
}

export const enum BLOG_STATUS {
  PUBLISH = 'PUBLISH',
  DRAFT = 'DRAFT',
}

export function checkIsPublicBlog(status: string) {
  return status === BLOG_STATUS.PUBLISH;
}
